import e from "./index89.js";
import t from "./index97.js";
import n from "./index103.js";
//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/createTheme.js
function r(t, n, r) {
	t.colorSchemes && r && (t.colorSchemes[n] = {
		...r !== !0 && r,
		palette: e({
			...r === !0 ? {} : r.palette,
			mode: n
		})
	});
}
function i(e = {}, ...i) {
	let { palette: a, cssVariables: o = !1, colorSchemes: s = a ? void 0 : { light: !0 }, defaultColorScheme: c = a?.mode, ...l } = e, u = c || "light", d = s?.[u], f = {
		...s,
		...a ? { [u]: {
			...typeof d != "boolean" && d,
			palette: a
		} } : void 0
	};
	if (o === !1) {
		if (!("colorSchemes" in e)) return t(e, ...i);
		let n = a;
		"palette" in e || f[u] && (f[u] === !0 ? u === "dark" && (n = { mode: "dark" }) : n = f[u].palette);
		let o = t({
			...e,
			palette: n
		}, ...i);
		return o.defaultColorScheme = u, o.colorSchemes = f, o.palette.mode === "light" && (o.colorSchemes.light = {
			...f.light !== !0 && f.light,
			palette: o.palette
		}, r(o, "dark", f.dark)), o.palette.mode === "dark" && (o.colorSchemes.dark = {
			...f.dark !== !0 && f.dark,
			palette: o.palette
		}, r(o, "light", f.light)), o;
	}
	return !a && !("light" in f) && u === "light" && (f.light = !0), n({
		...l,
		colorSchemes: f,
		defaultColorScheme: u,
		...typeof o != "boolean" && o
	}, ...i);
}
//#endregion
export { i as default };

//# sourceMappingURL=index104.js.map